import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
	selector: 'search-filter-disclaimer',
	template: `
		<p class="filterNote" [ngClass]="{ 'filterNote--new': newStyleForFilters }">
			Our Filters are provided as a guide only.
			<a href="/shop/content/dietary-and-lifestyle-filters" class="link--underline">Find out more</a>
		</p>
	`,
	imports: [NgClass],
	styleUrls: ['./filter-disclaimer.component.scss'],
	standalone: true,
})
export class FilterDisclaimerComponent {
	@Input() newStyleForFilters = false;
}
